import React from 'react';
const IconMiscText = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M13.25 7.5L19 7.5V5H13.25H10.75H5V7.5L10.75 7.5V19H13.25V7.5Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscText;